import { GetFromScript } from "../../services/script-data.service";
import { GetTranslations } from "../../services/translation.service";
import { Validator } from "vee-validate";

const dictionary = GetTranslations("postcode");
const validPostcodes = GetFromScript("valid-postcodes");

Validator.extend("postcode", {
    getMessage: (field) => dictionary.errorMessage,
    validate: (value) => validPostcodes.includes(value),
});